module.exports = __webpack_public_path__ + "img/delivery_icon.39e3b334.svg";